// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import packageInfo from '../../package.json';

export const environment = {
  env: 'local',
  app_url: 'https://superpay23.deivi.me',

  api_url: 'https://apigateway.deivi.me/api',
  // api_url: 'http://10.8.0.1:3000/api',
  // api_url: 'https://6495-216-147-125-196.ngrok-free.app/api',
  // api_url: "https://apigateway-test.superpay23.com/api",

  enableEncryption: false,
  // Migración JWT→cookie httpOnly (Fase 2). OFF = comportamiento actual (header +
  // localStorage). ON = modo cookie (withCredentials, sin header, sesión vía /auth/me,
  // X-CSRF-Token). Requiere Fase 1 backend desplegada. Activado y verificado en test
  // (login + cookies, /auth/me por cookie, logout con revocación server-side).
  useCookieAuth: true,
  // enableEncryption: false,
  encryptionKey: 'dAsIIf2AxyVpsPHtiJnb2ufSPVNQOwpwIDAQAB',
  appId: 'superpay23',
  turnstileSiteKey: '0x4AAAAAAD0hiQJAO2AO6B5J',

  appVersion: packageInfo.version,
  production: false,
  public_key:
    '-----BEGIN PUBLIC KEY-----\n' +
    'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDXj5FvYExVH9A/ZGpE7CfP2kTp\n' +
    'Zry5EqeRgavQxP93g3HmH8tz83sgIFURXOKIzWr/RjB3MxBR6sa1s2dBZhkFufR5\n' +
    's6H1zJSOKRhZaypN6a483By3LhgkA2kekID/dAsIIf2ALx2aB4ENU3Bt/HxyVpsP\n' +
    'HtiJnb2ufSPVNQOwpwIDAQAB\n' +
    '-----END PUBLIC KEY-----'
};
